import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import ServersTable from "./ServersTable";
import ServersHeader from "./ServersHeader";
import ServersDrawer from "./ServersDrawer";
import ServersDeleteMOdal from "./ServersDeleteModal";
import ServerExport from "./ServerExportInfo";
import PendingEdgeEnrollments from "./PendingEdgeEnrollments";
import EdgeApplianceInventory from "./EdgeApplianceInventory";
import ServersUpdateModal from "./ServersUpdateModal";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const ServersPage = () => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  // Reads SCREEN_PERMISSION["servers"] -- the same declaration Layout.tsx's
  // sidebar link reads.
  const allowed = useScreenPermission("servers");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {allowed ? (
        <div>
          <div className={`layout__contentPage__${theme}`}>
            <ServersHeader />
            <EdgeApplianceInventory />
            <PendingEdgeEnrollments />
            <ServersTable />
            <ServersDrawer />
            <ServersDeleteMOdal />
            <ServersUpdateModal />
            <ServerExport />
          </div>
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default ServersPage;
